export default "/profile/images/instruction-2-en.webp?7415aff8391f7c31e82e06f8ba77bea7";